import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewComponent } from './pages/view/view.component';
import { ListingComponent } from './pages/listing/listing.component';
import { GetSecondHandSuppliesOrdersByPkResolver } from './resolvers/get-second-hand-supplies-orders-by-pk.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full'
  },
  {
    path: 'list/:status',
    component: ListingComponent
  },
  {
    path: 'list',
    component: ListingComponent
  },
  {
    path: 'view/:id',
    component: ViewComponent,
    resolve:{
      oldSecondHandSuppliesOrder: GetSecondHandSuppliesOrdersByPkResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreOwnedOrdersRoutingModule { }
